import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IFlightQuotation,
  IHotelQuotation,
  IQuotation,
  IQuotationInitialState,
  IVisaQuotation,
} from "./quotationModel";
import {
  createFlightQuotation,
  createHotelQuotation,
  createQuotationStep1,
  createQuotationStep2,
  createVisaQuotation,
  deleteFlightQuotation,
  deleteHotelQuotation,
  deleteQuotation,
  deleteVisaQuotation,
  getAllFlightQuotations,
  getAllHotelQuotations,
  getAllQuotations,
  getAllVisaQuotations,
  getCustomQuotationMessageForCopy,
  getFlightQuotationByID,
  getFlightQuotationHistoryByParentID,
  getFlightQuotationMessageForCopy,
  getHotelQuotationByID,
  getHotelQuotationHistoryByParentID,
  getHotelQuotationMessageForCopy,
  getQuotationByID,
  getQuotationHistoryByParentID,
  getVisaQuotationByID,
  getVisaQuotationHistoryByParentID,
  getVisaQuotationMessageForCopy,
  sendQuotationByEmail,
  updateFlightQuotation,
  updateHotelQuotation,
  updateQuotationStep1,
  updateVisaQuotation,
} from "./services/quotation.services";

const initialState: IQuotationInitialState = {
  loading: false,
  messageLoading: false,
  error: "",
  QuotationType: "package",
  QuotationList: [],
  QuotationHistoryList: [],
  QuotationID: null,
  ActiveStep: 0,
  AccomodationDeleteIndex: -1,
  HotelRateIndex: -1,
  TransportDeleteIndex: -1,
  MiscellaneousDeleteIndex: -1,
  SightSeenDeleteIndex: -1,
  TourItineraryDeleteIndex: -1,
  IsWOBifurcation: false,
  QuotationDetail: {
    Name: "",
    MobileNo: "",
    CountryCode: "",
    EmailID: "",
    StartDate: "",
    EndDate: "",
    PickUpPlace: "",
    PickUpDate: "",
    DropPlace: "",
    DropDate: "",
    TermsNCondition: "",
    AccommodationCurrencyName: "",
    TransportaionCurrencyName: "",
    MiscellaneousCurrencyName: "",
    SightSeenCurrencyName: "",
    CreatedOn: "",
    FoodPreferenceID: null,
    TotalRoom: null,
    TotalAdult: null,
    TotalCWB: null,
    TotalCNB: null,
    Travelers: null,
    ExtraAdult: null,
    HotelRooms: [],
    TotalAccommodationRate: null,
    DriverAllowance: null,
    TotalTax: null,
    TotalTransportation: null,
    TotalMiscellaneous: null,
    TotalSightSeen: null,
    AccommodationMarkup: null,
    TransportMarkup: null,
    MiscellaneousMarkup: null,
    SightSeenMarkup: null,
    TotalMarkup: null,
    Accommodations: [],
    Transportations: [],
    Miscellaneous: [],
    SightSeen: [],
    Itinary: [],
    TourItinerary: [],
    CompanyDetails: {
      CompanyName: "",
      CityName: "",
      StateName: "",
      CountryName: "",
      Address: "",
      CityID: null,
      StateID: null,
      CountryID: null,
      Pincode: "",
      OwnerName: "",
      MobileNo: "",
      EmailID: "",
      PANNo: "",
      GSTNo: "",
      AadharNo: "",
      BankName: "",
      BankBranch: "",
      BankAddress: "",
      BankAccountNo: "",
      BankIFSCCode: "",
      CompanyLogo: "",
      IsActive: 1,
      IsDefault: false,
    },

    Initial: "",
    LeadSourceID: null,
    SectorID: null,
    CompanyID: null,
    Type: "",
    DiscountAmt: null,
    GstPer: null,
    GstValue: null,
    isTCS: false,
    TCS: null,
    FinalAmt: null,
    AccommodationConversionRate: 1,
    TransportaionConversionRate: 1,
    MiscellaneousConversionRate: 1,
    SightSeenConversionRate: 1,
    AccommodationCurrencyID: 1,
    TransportaionCurrencyID: 1,
    MiscellaneousCurrencyID: 1,
    SightSeenCurrencyID: 1,
  },
  QuotationFilterDetails: {
    filterContactID: "",
    filterLeadID: "",
    filterInquiryID: "",
    filterName: "",
    filterMobileNo: "",
    filterEmailID: "",
    filterPickUpPlace: "",
    filterDropPlace: "",
    filterDateType: null,
    filterFromDate: "",
    filterToDate: "",
  },
  FlightQuotationList: [],
  FlightQuotationHistoryList: [],
  FlightQuotationID: null,
  FlightQuotationDetail: {
    ParentID: null,
    FlightQuotationNo: "",
    FlightScope: 1,
    VendorID: null,
    CurrencyID: null,
    CompanyID: null,
    FlightClassID: null,
    TripType: "One Way",
    TextBaseDescription: "",
    IsRefundable: false,
    IsFlightRateMayBeChanged: false,
    AirlineID: null,
    AirlineNo: "",
    FromAirportID: null,
    ToAirportID: null,
    DepartureDate: "",
    DepartureTime: "",
    ArrivalDate: "",
    ArrivalTime: "",
    Stops: "",
    AdultsCost: null,
    AdultsMarkup: null,
    ChildCost: null,
    ChildMarkup: null,
    InfantCost: null,
    InfantMarkup: null,
    GrandTotal: null,
    FareRules: "",
    IsSharePPPrice: false,
  },
  FlightQuotationFilterDetails: {
    filterVendorID: null,
    filterAirlineName: "",
    filterFromAirportID: null,
    filterToAirportID: null,
    filterDepartureDate: "",
    filterArrivalDate: "",
    filterTripType: null,
    filterCreatedBy: null,
  },
  HotelQuotationList: [],
  HotelQuotationHistoryList: [],
  HotelQuotationID: null,
  HotelQuotationDetail: {
    ParentID: null,
    ID: null,
    ContactID: null,
    CompanyID: null,
    LeadID: null,
    InquiryID: null,
    Initial: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    MobileNo: "",
    NationalityID: null,
    Nationality: "",
    HotelID: "",
    CityID: null,
    CityName: "",
    Rating: "",
    RoomTypeID: null,
    RoomType: "",
    HotelAddress: "",
    CheckInDate: "",
    CheckOutDate: "",
    NoOfNights: null,
    TotalAdult: null,
    TotalChild: null,
    TotalRoom: null,
    MealTypeID: null,
    FoodPreferenceName: "",
    Remarks: "",
    TermsAndCondition: "",
    RoomRatePerNight: null,
    ExtraAdultRatePerNight: null,
    TotalRoomCost: null,
    TaxesAndFees: null,
    ServiceCharges: null,
    MarkupPercentage: null,
    GSTID: null,
    GSTPer: null,
    GSTAmount: null,
    TotalAmount: null,
    HotelRooms: [],
  },
  HotelQuotationFilterDetails: {
    CustomerName: "",
    EmailID: "",
    MobileNo: "",
    HotelName: "",
  },

  VisaQuotationList: [],
  VisaQuotationHistoryList: [],
  VisaQuotationID: null,
  VisaQuotationDetail: {
    ParentID: null,
    ID: null,
    ContactID: null,
    LeadID: null,
    InquiryID: null,
    Initial: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    MobileNo: "",

    CompanyID: null,
    NationalityID: null,
    DOB: "",
    PassportNumber: "",
    PassportExpiryDate: "",
    MaritalStatus: "",
    CurrentAddress: "",
    VisaCountryID: null,
    VisaCategoryID: null,
    TravelDate: "",
    Duration: null,
    TravelPurposeID: null,
    EntryTypeID: null,
    ProcessingOptionID: null,
    AdditionalServicesID: "",
    DocumentsID: "",
    EmploymentStatusID: null,
    Income: null,
    CompanyName: "",
    Designation: "",
    BankBalance: null,
    SponsorshipID: null,
    AdditionalInfo: "",
    AdditionalServices: [],
  },
  VisaQuotationFilterDetails: {
    CustomerName: "",
    EmailID: "",
    MobileNo: "",
  },
};

const quotationSlice = createSlice({
  name: "quotation",
  initialState,
  reducers: {
    clearQuotationInformation: (state) => {
      state.QuotationDetail = initialState.QuotationDetail;
    },
    setQuotationInformation: (state, action) => {
      state.QuotationDetail = action.payload;
    },
    clearFlightQuotationInformation: (state) => {
      state.FlightQuotationDetail = initialState.FlightQuotationDetail;
    },
    setFlightQuotationInformation: (state, action) => {
      state.FlightQuotationDetail = action.payload;
    },
    clearHotelQuotationInformation: (state) => {
      state.HotelQuotationDetail = initialState.HotelQuotationDetail;
    },
    setHotelQuotationInformation: (state, action) => {
      state.HotelQuotationDetail = action.payload;
    },
    clearVisaQuotationInformation: (state) => {
      state.VisaQuotationDetail = initialState.VisaQuotationDetail;
    },
    setVisaQuotationInformation: (state, action) => {
      state.VisaQuotationDetail = action.payload;
    },
    setQuotationPaymentBifurcation: (state, action) => {
      state.IsWOBifurcation = action.payload;
    },
    setQuotationID: (state, action) => {
      state.QuotationID = action.payload;
    },
    clearQuotationID: (state) => {
      state.QuotationID = initialState.QuotationID;
    },
    setFlightQuotationID: (state, action) => {
      state.FlightQuotationID = action.payload;
    },
    clearFlightQuotationID: (state) => {
      state.FlightQuotationID = initialState.FlightQuotationID;
    },
    setHotelQuotationID: (state, action) => {
      state.HotelQuotationID = action.payload;
    },
    clearHotelQuotationID: (state) => {
      state.HotelQuotationID = initialState.HotelQuotationID;
    },
    setVisaQuotationID: (state, action) => {
      state.VisaQuotationID = action.payload;
    },
    clearVisaQuotationID: (state) => {
      state.VisaQuotationID = initialState.VisaQuotationID;
    },
    setActiveStep: (state, action) => {
      state.ActiveStep = action.payload;
    },
    clearActiveStep: (state) => {
      state.ActiveStep = initialState.ActiveStep;
    },
    increaseActiveStep: (state) => {
      state.ActiveStep = state.ActiveStep + 1;
    },
    decreaseActiveStep: (state) => {
      state.ActiveStep = state.ActiveStep - 1;
    },
    setAccomodationDeleteIndex: (state, action) => {
      state.AccomodationDeleteIndex = action.payload;
    },
    setHotelRateIndex: (state, action) => {
      state.HotelRateIndex = action.payload;
    },
    setTransportDeleteIndex: (state, action) => {
      state.TransportDeleteIndex = action.payload;
    },
    setMiscellaneousDeleteIndex: (state, action) => {
      state.MiscellaneousDeleteIndex = action.payload;
    },
    setSightSeenDeleteIndex: (state, action) => {
      state.SightSeenDeleteIndex = action.payload;
    },
    setTourItineraryDeleteIndex: (state, action) => {
      state.TourItineraryDeleteIndex = action.payload;
    },
    setQuotationFilterDetails: (state, action) => {
      state.QuotationFilterDetails = action.payload;
    },
    clearQuotationFilterDetails: (state) => {
      state.QuotationFilterDetails = initialState.QuotationFilterDetails;
    },
    setFlightQuotationFilterDetails: (state, action) => {
      state.FlightQuotationFilterDetails = action.payload;
    },
    clearFlightQuotationFilterDetails: (state) => {
      state.FlightQuotationFilterDetails =
        initialState.FlightQuotationFilterDetails;
    },
    setHotelQuotationFilterDetails: (state, action) => {
      state.HotelQuotationFilterDetails = action.payload;
    },
    clearHotelQuotationFilterDetails: (state) => {
      state.HotelQuotationFilterDetails =
        initialState.HotelQuotationFilterDetails;
    },
    setVisaQuotationFilterDetails: (state, action) => {
      state.VisaQuotationFilterDetails = action.payload;
    },
    clearVisaQuotationFilterDetails: (state) => {
      state.VisaQuotationFilterDetails =
        initialState.VisaQuotationFilterDetails;
    },
    setQuotationType: (state, action) => {
      state.QuotationType = action.payload;
    },
    clearQuotationType: (state) => {
      state.QuotationType = initialState.QuotationType;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllQuotations.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllQuotations.fulfilled,
      (state, action: PayloadAction<IQuotation[]>) => {
        state.loading = false;
        state.QuotationList = action.payload || [];
      },
    );
    builder.addCase(getAllQuotations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.QuotationList = [];
    });

    builder.addCase(createQuotationStep1.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createQuotationStep1.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createQuotationStep1.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createQuotationStep2.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createQuotationStep2.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createQuotationStep2.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateQuotationStep1.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateQuotationStep1.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateQuotationStep1.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getQuotationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getQuotationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.QuotationDetail = action.payload;
    });
    builder.addCase(getQuotationByID.rejected, (state, action) => {
      state.loading = false;
      state.QuotationDetail = initialState.QuotationDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(sendQuotationByEmail.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(sendQuotationByEmail.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(sendQuotationByEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getQuotationHistoryByParentID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getQuotationHistoryByParentID.fulfilled,
      (state, action: PayloadAction<IQuotation[]>) => {
        state.loading = false;
        state.QuotationHistoryList = action.payload || [];
      },
    );
    builder.addCase(getQuotationHistoryByParentID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.QuotationHistoryList = [];
    });

    // Flight Quotation related cases
    builder.addCase(getAllFlightQuotations.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllFlightQuotations.fulfilled,
      (state, action: PayloadAction<IFlightQuotation[]>) => {
        state.loading = false;
        state.FlightQuotationList = action.payload || [];
      },
    );
    builder.addCase(getAllFlightQuotations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.FlightQuotationList = [];
    });

    builder.addCase(createFlightQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createFlightQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createFlightQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateFlightQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateFlightQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateFlightQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteFlightQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteFlightQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteFlightQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getFlightQuotationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getFlightQuotationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.FlightQuotationDetail = action.payload;
    });
    builder.addCase(getFlightQuotationByID.rejected, (state, action) => {
      state.loading = false;
      state.FlightQuotationDetail = initialState.FlightQuotationDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getFlightQuotationHistoryByParentID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getFlightQuotationHistoryByParentID.fulfilled,
      (state, action: PayloadAction<IFlightQuotation[]>) => {
        state.loading = false;
        state.FlightQuotationHistoryList = action.payload || [];
      },
    );
    builder.addCase(
      getFlightQuotationHistoryByParentID.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.FlightQuotationHistoryList = [];
      },
    );

    // Hotel Quotation related cases
    builder.addCase(getAllHotelQuotations.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllHotelQuotations.fulfilled,
      (state, action: PayloadAction<IHotelQuotation[]>) => {
        state.loading = false;
        state.HotelQuotationList = action.payload || [];
      },
    );
    builder.addCase(getAllHotelQuotations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HotelQuotationList = [];
    });

    builder.addCase(createHotelQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createHotelQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createHotelQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateHotelQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateHotelQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHotelQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteHotelQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteHotelQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteHotelQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHotelQuotationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getHotelQuotationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.HotelQuotationDetail = action.payload;
    });
    builder.addCase(getHotelQuotationByID.rejected, (state, action) => {
      state.loading = false;
      state.HotelQuotationDetail = initialState.HotelQuotationDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHotelQuotationHistoryByParentID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getHotelQuotationHistoryByParentID.fulfilled,
      (state, action: PayloadAction<IHotelQuotation[]>) => {
        state.loading = false;
        state.HotelQuotationHistoryList = action.payload || [];
      },
    );
    builder.addCase(
      getHotelQuotationHistoryByParentID.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.HotelQuotationHistoryList = [];
      },
    );
    // Visa Quotation related cases
    builder.addCase(getAllVisaQuotations.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVisaQuotations.fulfilled,
      (state, action: PayloadAction<IVisaQuotation[]>) => {
        state.loading = false;
        state.VisaQuotationList = action.payload || [];
      },
    );
    builder.addCase(getAllVisaQuotations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaQuotationList = [];
    });

    builder.addCase(createVisaQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createVisaQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createVisaQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateVisaQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateVisaQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateVisaQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteVisaQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVisaQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVisaQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getVisaQuotationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getVisaQuotationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.VisaQuotationDetail = action.payload;
    });
    builder.addCase(getVisaQuotationByID.rejected, (state, action) => {
      state.loading = false;
      state.VisaQuotationDetail = initialState.VisaQuotationDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getVisaQuotationHistoryByParentID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getVisaQuotationHistoryByParentID.fulfilled,
      (state, action: PayloadAction<IVisaQuotation[]>) => {
        state.loading = false;
        state.VisaQuotationHistoryList = action.payload || [];
      },
    );
    builder.addCase(
      getVisaQuotationHistoryByParentID.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.VisaQuotationHistoryList = [];
      },
    );

    builder.addCase(getCustomQuotationMessageForCopy.pending, (state) => {
      state.messageLoading = true;
      state.error = "";
    });
    builder.addCase(getCustomQuotationMessageForCopy.fulfilled, (state) => {
      state.messageLoading = false;
    });
    builder.addCase(
      getCustomQuotationMessageForCopy.rejected,
      (state, action) => {
        state.messageLoading = false;
        state.error = action.error.message || "Something went wrong";
      },
    );

    builder.addCase(getFlightQuotationMessageForCopy.pending, (state) => {
      state.messageLoading = true;
      state.error = "";
    });
    builder.addCase(getFlightQuotationMessageForCopy.fulfilled, (state) => {
      state.messageLoading = false;
    });
    builder.addCase(
      getFlightQuotationMessageForCopy.rejected,
      (state, action) => {
        state.messageLoading = false;
        state.error = action.error.message || "Something went wrong";
      },
    );

    builder.addCase(getHotelQuotationMessageForCopy.pending, (state) => {
      state.messageLoading = true;
      state.error = "";
    });
    builder.addCase(getHotelQuotationMessageForCopy.fulfilled, (state) => {
      state.messageLoading = false;
    });
    builder.addCase(
      getHotelQuotationMessageForCopy.rejected,
      (state, action) => {
        state.messageLoading = false;
        state.error = action.error.message || "Something went wrong";
      },
    );

    builder.addCase(getVisaQuotationMessageForCopy.pending, (state) => {
      state.messageLoading = true;
      state.error = "";
    });
    builder.addCase(getVisaQuotationMessageForCopy.fulfilled, (state) => {
      state.messageLoading = false;
    });
    builder.addCase(
      getVisaQuotationMessageForCopy.rejected,
      (state, action) => {
        state.messageLoading = false;
        state.error = action.error.message || "Something went wrong";
      },
    );
  },
});

export const {
  setQuotationInformation,
  clearQuotationInformation,
  setFlightQuotationInformation,
  clearFlightQuotationInformation,
  setHotelQuotationInformation,
  clearHotelQuotationInformation,
  setVisaQuotationInformation,
  clearVisaQuotationInformation,
  clearQuotationID,
  setQuotationID,
  setQuotationPaymentBifurcation,
  clearFlightQuotationID,
  setFlightQuotationID,
  clearHotelQuotationID,
  setHotelQuotationID,
  clearVisaQuotationID,
  setVisaQuotationID,
  setAccomodationDeleteIndex,
  setHotelRateIndex,
  setTransportDeleteIndex,
  setMiscellaneousDeleteIndex,
  setSightSeenDeleteIndex,
  setTourItineraryDeleteIndex,
  setActiveStep,
  clearActiveStep,
  increaseActiveStep,
  decreaseActiveStep,
  setQuotationFilterDetails,
  clearQuotationFilterDetails,
  setFlightQuotationFilterDetails,
  clearFlightQuotationFilterDetails,
  setHotelQuotationFilterDetails,
  clearHotelQuotationFilterDetails,
  setVisaQuotationFilterDetails,
  clearVisaQuotationFilterDetails,
  clearQuotationType,
  setQuotationType,
} = quotationSlice.actions;
export default quotationSlice.reducer;
